import { render } from "./AssessmentInput.vue?vue&type=template&id=06822e30"
import script from "./AssessmentInput.vue?vue&type=script&lang=js"
export * from "./AssessmentInput.vue?vue&type=script&lang=js"

import "./AssessmentInput.vue?vue&type=style&index=0&id=06822e30&lang=css"
script.render = render

export default script